// Assets
import './Selector.css';
import { useState, useEffect, useCallback, useRef } from 'react';
import { query, collection, where, getDocs } from 'firebase/firestore';
import { db } from '../../firebase';
import { useParams } from 'react-router-dom';
import { designsCollection, COLORS, FUENTES } from '../../utils';

const Selector = (props) => {
    let params = useParams();
    const designsContainer = useRef(null);
    const [designs, setDesigns] = useState([]);
    const [loading, setLoading] = useState(false);
    const [picked, setPicked] = useState('');
    const [error, setError] = useState({});
    const [hideColorSelector, setHideColorSelector] = useState(true);
    const [hideFontSelector, setHideFontSelector] = useState(true);
    const [iniciales, setIniciales] = useState(false);
    const [availableColorList, setAvailableColorList] = useState(COLORS);
    const [availableFontList, setAvailableFontList] = useState(FUENTES);
    const { getDesign, getText, getError } = props;

    const fetchDesigns = useCallback(async () => {
        setLoading(true);
        const fetchedDesigns = [];
        const designsRef = collection(db, designsCollection);
        const q = query(designsRef, where('product', '==', Number(params.productId)), where('active', '==', true));
        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => {
            fetchedDesigns.push(doc.data());
        });
        if (fetchedDesigns.length !== 0) {
            setDesigns(fetchedDesigns);
        }
        setLoading(false);
    }, [params.productId]);

    const showToolTip = (e) => {
        const tooltip = e.currentTarget.parentElement.querySelector('span');
        if (!tooltip) return;

        tooltip.classList.add('opacity-100');

        setTimeout(() => {
            tooltip.classList.remove('opacity-100');
        }, 1000);
    };

    const onChange = (evt) => {
        showToolTip(evt);
        setError({});
        switch (evt.target.name) {
            case 'name':
                if (!picked.design) {
                    setError({ property: 'design', message: 'Por favor selecciona un diseño.' });
                    getError('design');
                } else if (!picked.font) {
                    setError({ property: 'font', message: 'Por favor selecciona una tipografía.' });
                    getError('font');
                } else if (!picked.color) {
                    setError({ property: 'color', message: 'Por favor selecciona un color.' });
                    getError('color');
                }

                setPicked({ ...picked, name: evt.target.value });
                getText({ name: evt.target.name, value: evt.target.value });
                break;
            case 'lastName':
                getText({ name: evt.target.name, value: evt.target.value });
                break;
            case 'font':
                if (!picked.name) {
                    setError({ property: 'fname', message: 'Debe ingresar un nombre.' });
                    getError('fname');
                } else if (!picked.color) {
                    setError({ property: 'color', message: 'Por favor selecciona un color.' });
                    getError('color');
                }

                setPicked({ ...picked, font: evt.target.value });
                getText({ name: evt.target.name, value: evt.target.value });
                break;
            case 'color':
                if (!picked.name) {
                    setError({ property: 'fname', message: 'Debe ingresar un nombre.' });
                    getError('fname');
                } else if (!picked.font) {
                    setError({ property: 'font', message: 'Por favor selecciona una tipografía.' });
                    getError('font');
                }

                setPicked({ ...picked, color: evt.target.value });
                getText({ name: evt.target.name, value: evt.target.value });
                break;
            default:
                return false;
        }
    };

    const pickDesign = (design) => {
        const {
            name,
            image,
            labels,
            maxLength1,
            maxLength2,
            defaultColor,
            availableColorList,
            availableFontList,
            defaultTypography,
            defaultAlignment,
            hideColorSelector,
            hideFontSelector,
            iniciales: designIniciales,
        } = design;

        setError({});
        setPicked({ ...picked, design: name, maxLength1, maxLength2 });
        setHideColorSelector(hideColorSelector);
        setHideFontSelector(hideFontSelector);
        setIniciales(!!designIniciales);

        if (availableColorList?.length) {
            setAvailableColorList(availableColorList);
        }

        if (availableFontList?.length) {
            setAvailableFontList(availableFontList);
        }

        getDesign({
            hideColorSelector,
            hideFontSelector,
            iniciales: !!designIniciales,
            name,
            image,
            labels,
            maxLength1,
            maxLength2,
            defaultColor,
            defaultTypography,
            defaultAlignment,
        });
    };

    useEffect(() => {
        if (!params?.productId) return;
        fetchDesigns();
    }, [params, fetchDesigns]);

    return (
        <div className="relative md:mt-0 et-mobile-selector-col">
            <div
                className={`relative bg-white py-4 px-6 border-l-8 border-etiquette shadow-lg ${
                    error.property === 'design' && 'border-glow'
                }`}>
                <h3 className="text-lg text-gray-600 font-semibold ml-2 mb-2">Selecciona un diseño</h3>
                {designs?.length > 0 ? (
                    <div ref={designsContainer} className="relative w-full overflow-x-scroll scroll-smooth pb-4">
                        <ul className="w-full flex flex-wrap max-h-96 overflow-y-scroll scroll-smooth justify-evenly lg:justify-normal">
                            {designs?.map((design, i) => {
                                const isNew = (() => {
                                    if (!design.createdAt) return false;
                                    const created = design.createdAt.toDate
                                        ? design.createdAt.toDate()
                                        : new Date(design.createdAt);
                                    const threeMonthsAgo = new Date();
                                    threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 3);
                                    return created > threeMonthsAgo;
                                })();
                                return (
                                    <li key={`${design.name}-${design.category}`} className="inline mx-1 relative">
                                        {isNew && (
                                            <span className="absolute top-1.5 right-1.5 z-10 bg-etiquette text-white text-[9px] font-bold px-2 py-1.5 rounded-full leading-none pointer-events-none">
                                                NUEVO
                                            </span>
                                        )}
                                        <button
                                            onClick={() => pickDesign(design)}
                                            className={`cursor-pointer et-design-btn relative overflow-hidden rounded-2xl border-4 hover:border-blue-300 ${
                                                picked.design === design.name ? 'border-etiquette' : 'border-gray-100'
                                            } transition-all duration-500`}>
                                            <img src={design.thumbnail} alt={design.name} />
                                            <span className="relative bg-white text-xs font-semibold text-center text-gray-700 px-2 leading-3">
                                                {design.name}
                                            </span>
                                        </button>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                ) : (
                    <div className="text-center">
                        {!loading ? (
                            <p className="text-sm text-gray-400 text-center py-4">
                                Este producto no tiene diseños creados todavía.
                            </p>
                        ) : (
                            <div className="lds-ring">
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                            </div>
                        )}
                    </div>
                )}
                {error.property === 'design' && (
                    <div className="relative top-0 mx-auto py-2 mt-4 w-full text-center text-red-600 text-sm border-2 border-orange-600">
                        {error.message}
                    </div>
                )}
            </div>
            <div
                className={`relative lg:grid grid-cols-2 gap-4 my-2 bg-white py-6 px-8 border-l-8 border-etiquette shadow-lg ${
                    error.property === 'fname' && 'border-glow'
                }`}>
                {!picked.design && (
                    <div className="absolute inset-0 z-10 flex items-center justify-center backdrop-blur-sm bg-white/70 rounded">
                        <p className="text-gray-500 font-medium text-lg">Para comenzar, seleccione un diseño</p>
                    </div>
                )}
                <h3 className="col-span-2 text-lg text-gray-600 font-semibold">Escribe el texto</h3>
                <div>
                    <h4 className="text text-gray-600 font-medium">
                        {iniciales ? 'Iniciales' : 'Primera línea de texto'}
                    </h4>
                    <input
                        type="text"
                        onChange={onChange}
                        name="name"
                        className="
                            mt-1
                            p-5
                            py-3
                            block
                            w-full
                            rounded-md
                            border-gray-300
                            shadow-sm
                            focus:border-indigo-300 focus:ring-3 focus:ring-indigo-200/50
                        "
                        placeholder={iniciales ? 'Escriba las Iniciales (3 letras)' : 'Escriba el nombre'}
                        maxLength={picked.maxLength1 ? picked.maxLength1 : ''}
                    />
                </div>
                {!iniciales && (
                    <div>
                        <h4 className="text text-gray-600 font-medium">Segunda línea de texto</h4>
                        <input
                            type="text"
                            onChange={onChange}
                            name="lastName"
                            className="
                            mt-1
                            p-5
                            py-3
                            block
                            w-full
                            rounded-md
                            border-gray-300
                            shadow-sm
                            focus:border-indigo-300 focus:ring-3 focus:ring-indigo-200/50
                        "
                            placeholder="Escriba apellido (opcional)"
                            maxLength={picked.maxLength2 ? picked.maxLength2 : ''}
                        />
                    </div>
                )}
                {error.property === 'fname' && (
                    <div className="relative col-span-2 top-0 mx-auto py-2 mt-4 w-full text-center text-red-600 text-sm border-2 border-orange-600">
                        {error.message}
                    </div>
                )}
            </div>
            {/* <div className="lg:grid grid-cols-2 gap-6 shadow-lg"> */}
            {!hideFontSelector && (
                <div
                    className={`relative bg-white py-6 px-8 my-2 border-l-8 border-etiquette shadow-lg ${
                        error.property === 'font' && 'border-glow'
                    }`}>
                    <h3 className="text-lg text-gray-600 font-semibold mb-2">Selecciona el tipo de letra</h3>
                    <div className="grid grid-cols-2 md:grid-cols-5 gap-2">
                        {availableFontList.map((fuente, index) => {
                            const { name, value } = fuente;
                            return (
                                <button
                                    key={`font-${value}`}
                                    className={`cursor-pointer rounded-lg h-16 hover:bg-etiquette hover:text-white px-2 border-2 py-2 font_${value} ${
                                        picked.font === value
                                            ? 'border-etiquette bg-etiquette text-white'
                                            : 'border-gray-100 bg-gray-100 text-gray-500'
                                    } ${name === 'Sacramento' ? 'text-xl' : 'text-sm'}`}
                                    onClick={onChange}
                                    name="font"
                                    value={value}>
                                    {name}
                                </button>
                            );
                        })}
                    </div>
                    {error.property === 'font' && (
                        <div className="relative top-0 mx-auto py-2 mt-4 w-full text-center text-red-600 text-sm border-2 border-orange-600">
                            {error.message}
                        </div>
                    )}
                </div>
            )}
            {!hideColorSelector && (
                <div
                    className={`relative bg-white py-4 px-8 mb-2 border-l-8 border-etiquette shadow-lg ${
                        error.property === 'color' && 'border-glow'
                    }`}>
                    <h3 className="text-lg text-gray-600 font-semibold mb-2">Selecciona el color de letra</h3>
                    {availableColorList.map((color) => {
                        const { name, hex } = color;
                        return (
                            <div key={`color-${name}`} className="relative group inline-block">
                                <button
                                    className={`cursor-pointer w-12 h-12 m-1 text-black rounded border-2 hover:border-blue-500 palette_${hex} ${
                                        picked.color === name ? 'border-etiquette' : 'border-gray-200'
                                    }`}
                                    onClick={onChange}
                                    name="color"
                                    value={name}></button>
                                <span className="absolute -top-8 left-1/2 -translate-x-1/2 whitespace-nowrap bg-black text-white text-lg px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none z-10">
                                    {name}
                                </span>
                            </div>
                        );
                    })}
                    {error.property === 'color' && (
                        <div className="relative top-0 mx-auto py-2 mt-4 w-full text-center text-red-600 text-sm border-2 border-orange-600">
                            {error.message}
                        </div>
                    )}
                </div>
            )}
            {/* </div> */}
        </div>
    );
};

export default Selector;
